import React from 'react';
import { TableCell, TableRow } from '@/components/shared/table';
import OpportunityDefinition from './OpportunityDefinition';
import { OpportunityScore } from '@/types/opportunity';

interface OpportunityRowProps {
  opportunity: OpportunityScore;
  index: number;
}

const OpportunityRow = ({ opportunity, index }: OpportunityRowProps) => {
  return (
    <TableRow className="hover:bg-gray-50/50 transition-colors">
      <TableCell className="align-middle font-medium text-gray-700">{index + 1}</TableCell>
      <TableCell className="align-middle">
        <div className="flex items-center gap-3">
          <div 
            className="w-2 h-8 rounded-full" 
            style={{ backgroundColor: opportunity.quadrantColor }} 
          />
          <OpportunityDefinition name={opportunity.Name} />
        </div>
      </TableCell>
      <TableCell className="align-middle text-right font-medium">
        {Math.round(opportunity.valueScore)}%
      </TableCell>
      <TableCell className="align-middle text-right font-medium">
        {Math.round(opportunity.feasibilityScore)}%
      </TableCell>
      <TableCell className="align-middle text-right font-medium">
        {Math.round((opportunity.valueScore * 0.6 + opportunity.feasibilityScore * 0.4))}%
      </TableCell>
    </TableRow>
  );
};

export default OpportunityRow;